import React from 'react';
import LogoText from './LogoText';
import LogoIcon from './LogoIcon';

import { getWidthAndHeight } from './helpers';

export default function Logo({ width, height, color }) {
  const [svgWidth, svgHeight] = getWidthAndHeight({
    width,
    height,
    defaultWidth: 204,
    defaultHeight: 60,
    aspectRatio: 3.4
  });

  /* 
    Icon
      width: 58
      height: 48
    Text
      width: 138
      height: 48
      x: 66
      y: 12
      dx: 65
      dy: 11
    Logo:
      width: 204
      height: 60
  */
  const iconWidthRatio = 58 / 204;
  const textWidthRatio = 138 / 204;
  const spaceBetweenRatio = 8 / 204;
  const textTranslateYRatio = 12 / 60;
  const iconWidth = svgWidth * iconWidthRatio
  const textWidth = svgWidth * textWidthRatio
  const spaceBetween = svgWidth * spaceBetweenRatio;
  const textTranslateX = spaceBetween + iconWidth - 1;
  const textTranslateY = svgHeight * textTranslateYRatio - 1;

  return (
    <svg width={svgWidth} height={svgHeight} viewBox={`0 0 ${svgWidth} ${svgHeight}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <LogoIcon width={iconWidth} color={color  || "#0078FF"} />
      </g>
      <g transform={`translate(${textTranslateX}, ${textTranslateY})`}>
        <LogoText width={textWidth} color={color || "#000A3D"} />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// app/components/Logo/Logo.jsx